var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.33337 6.21167C1.33337 8.69787 4.01299 11.3273 5.97453 12.9191C6.86251 13.6397 7.30651 14 8.00004 14C8.69357 14 9.13757 13.6397 10.0256 12.9191C11.9871 11.3273 14.6667 8.69787 14.6667 6.21165C14.6667 2.05832 10.9999 0.507666 8.00004 3.71608C5.00015 0.507666 1.33337 2.05832 1.33337 6.21167Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.16602C11.2761 4.16602 11.5 4.38988 11.5 4.66602V5.49936H12.3333C12.6094 5.49936 12.8333 5.72322 12.8333 5.99936C12.8333 6.2755 12.6094 6.49936 12.3333 6.49936H11.5V7.33268C11.5 7.60882 11.2761 7.83268 11 7.83268C10.7238 7.83268 10.5 7.60882 10.5 7.33268V6.49936H9.66663C9.39049 6.49936 9.16663 6.2755 9.16663 5.99936C9.16663 5.72322 9.39049 5.49936 9.66663 5.49936H10.5V4.66602C10.5 4.38988 10.7238 4.16602 11 4.16602Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartPlusIcon);
export default __webpack_public_path__ + "static/media/heart-plus-icon.b9b4aa0a675b7e1f0bf8d44fb73ee179.svg";
export { ForwardRef as ReactComponent };